
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations([
      'setCurrentSection'
    ])
  },
  mounted() {
    const onClick = (e, elem) => {
      e.preventDefault();
      const link = elem.dataset.to;
      
      if(link.indexOf('/') > -1)
        this.$router.push(link);
      else
        this.setCurrentSection(link);
    }

    const addClickEventToElem = (elem) => {
      elem.addEventListener('click', (e) => onClick(e, elem));
    };

    this.$el.querySelectorAll('a[data-to]').forEach(addClickEventToElem);
  }
}



// WEBPACK FOOTER //
// ./components/mixins/Link.vue